// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GoogleMapLazy{display:flex}.GoogleMapLazy>.vue-map-container{flex-grow:1}@media(min-width:1024px){.GoogleMapLazy>.PlaceholderBox{min-height:480px}}@media(min-width:1279px){.GoogleMapLazy>.PlaceholderBox{min-height:400px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
